export default function HowToBuy() {
  return (
    <section className="tw-bg-white tw-pt-[88px] tw-pb-10 tw-text-center">
      <div className="tw-max-w-[1120px] tw-mx-auto tw-px-6 xl:tw-px-0 tw-flex tw-flex-col tw-items-center tw-gap-12">
        <h2 className="tw-text-3xl md:tw-text-[40px] tw-leading-[normal] tw-font-semibold tw-tracking-[-0.01em] tw-text-[#111]">
          How to buy the MecTURING Accidental Care Plan?
        </h2>

        <p className="tw-max-w-[760px] tw-text-base md:tw-text-[17px] tw-leading-7 tw-text-[#4B5563]">
          You can add MecTURING Care to your cart when you buy a MecTURING
          product on{" "}
          <a
            href="https://www.mecturing.in/"
            target="_blank"
            rel="noopener noreferrer"
            className="tw-font-semibold tw-text-[#111] tw-underline"
          >
            https://www.mecturing.in/
          </a>
          . Product owners who are eligible for a MecTURING Care Plan can find
          an offer on MecTURING’s website.
        </p>
      </div>
    </section>
  );
}
